'use client';
import Image from 'next/image';
import React from 'react';
import emtyCart from '@/public/assets/EmptyCart.svg';
import { Button } from '@/src/components/ui/button';
import { Routes } from '@/src/routes/routes';
import { Link } from '@/src/i18n/navigation';
import { signIn, useSession } from 'next-auth/react';
import { UserIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Container from '@/src/components/ui/container';

const EmtyCart = ({
  onCloseCartSheet,
  isSlide,
}: {
  onCloseCartSheet?: () => void;
  isSlide?: boolean;
}) => {
  const t = useTranslations('cart');
  const { data } = useSession();
  const handleCloseSheet = () => {
    if (onCloseCartSheet) onCloseCartSheet();
  };
  return (
    <div className="@container text-center">
      <div className="mx-auto flex w-[90%] flex-col place-items-center lg:w-2/4 lg:py-6">
        <Image src={emtyCart} alt="logo" className="pointer-events-none w-56 opacity-10" />
        <h2
          className={`${isSlide ? 'text-[clamp(1.5rem,1.07rem_+_2.1dvw,2.8rem)]' : 'text-[clamp(2.2rem,1.07rem_+_3.2dvw,3rem)]'} text-primary/30 object-contain font-bold capitalize`}
        >
          {t('EmtyCart')}
        </h2>
      </div>
      <div className="mx-auto flex w-full flex-wrap justify-center gap-2 px-6 lg:max-w-max lg:flex-nowrap">
        <Link href={Routes.stores} className="w-full shrink-0">
          <Button rounded={'full'} variant={'outline'} onClick={handleCloseSheet}>
            {t('start-shopping')}
          </Button>
        </Link>
        {!data && (
          <Button
            variant={'outline'}
            rounded={'full'}
            className="text-primary flex shrink-0 flex-row items-center justify-center space-x-2 rtl:space-x-reverse"
            onClick={() => signIn('keycloak')}
          >
            <p className={'text-lg font-bold'}>{t('login')}</p>
            <UserIcon />
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmtyCart;
